import { render, staticRenderFns } from "./ChangeAddressModal.vue?vue&type=template&id=ea50916c&scoped=true&"
import script from "./ChangeAddressModal.vue?vue&type=script&lang=js&"
export * from "./ChangeAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea50916c",
  null
  
)

export default component.exports